export const secureFileUrl = (url: string) => {
    if (!url) return '';
    
    // Check if this is an upload URL
    const uploadBaseUrl = '/wp-content/uploads/';
    if (url.includes(uploadBaseUrl)) {
        // Extract the relative path from the URL
        const relativePath = url.split(uploadBaseUrl)[1];
        if (relativePath) {
            // Create a secure URL
            return `${window.location.origin}/secure-file/${btoa(relativePath)}`;
        }
    }
    
    return url;
};